(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
  if (window.location.hash === '#cart-open') {
    history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
    let attempts = 0;
    const openDrawer = () => {
      const drawer = document.getElementById('CartDrawer');
      if (drawer?.classList.contains('is-opened')) return;
      document.querySelector('[data-sidebar-button][data-sidebar-id="CartDrawer"]')?.click();
      attempts += 1;
      if (attempts < 30) setTimeout(openDrawer, 250);
    };
    if (document.readyState === 'complete') {
      setTimeout(openDrawer, 100);
    } else {
      window.addEventListener('load', () => setTimeout(openDrawer, 100));
    }
  }

  } catch(e) { console.error(e); }
})();
})();
